const KEY = 'readinglist-theme'

export type Theme = 'light' | 'dark'

export function currentTheme(): Theme {
  try {
    const stored = localStorage.getItem(KEY)
    if (stored === 'light' || stored === 'dark') return stored
  } catch {
    // soukromé okno nebo zakázaná úložiště — prostě se řídíme systémem
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export function applyTheme(theme: Theme) {
  document.documentElement.classList.toggle('dark', theme === 'dark')
  try {
    localStorage.setItem(KEY, theme)
  } catch {
    // preference se prostě nezapamatuje, aplikace funguje dál
  }
}
